import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import Cookies from 'js-cookie';

const SHOPIFY_CART_CLEAR_COOKIE = 'shopifyCartClearCookie';

const useCartStore = create(
  persist(
    (set, get) => ({
      cartId: null,
      cart: { lines: { edges: [] } },

      setCartId: (cartId) => set({ cartId }),

      setCart: (cart) => set({ cart }),

      resetCart: (shouldReload = true) => {
        set({ cartId: null, cart: { lines: { edges: [] } } });
        Cookies.remove(SHOPIFY_CART_CLEAR_COOKIE);
        if (shouldReload) {
          window.location.reload();
        }
      },
    }),
    {
      name: 'shopify-cart-storage',
      partialize: (state) => ({ cartId: state.cartId }),
    }
  )
);

export default useCartStore;
